// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours come from CustomTheme/customTheme.css so buttons match
   every other Custom* component. */

.cbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: var(--cui-border-width) solid transparent;
  border-radius: var(--cui-radius);
  font-family: inherit;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  transition: background var(--cui-transition), border-color var(--cui-transition),
    color var(--cui-transition), box-shadow var(--cui-transition), transform 0.05s ease,
    opacity var(--cui-transition);
}

.cbtn:active:not(:disabled) {
  transform: scale(0.98);
}

.cbtn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.cbtn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.cbtn-full {
  width: 100%;
}

/* ---------- sizes (md matches the input height so rows line up) ---------- */

.cbtn-sm {
  min-height: 32px;
  padding: 5px 12px;
  font-size: 12.5px;
}

.cbtn-md {
  min-height: var(--cui-control-height);
  padding: 8px 16px;
  font-size: 13.5px;
}

.cbtn-lg {
  min-height: 48px;
  padding: 11px 22px;
  font-size: 15px;
}

/* ---------- primary: solid brand colour (submit / save) ---------- */

.cbtn-primary {
  background: linear-gradient(135deg, var(--cui-primary), var(--cui-primary-light));
  color: var(--cui-text-on-primary);
  box-shadow: 0 6px 16px -6px rgba(79, 95, 232, 0.55);
}

.cbtn-primary:hover:not(:disabled) {
  filter: brightness(1.06);
}

/* ---------- secondary: soft tint (search / filter) ---------- */

.cbtn-secondary {
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
}

.cbtn-secondary:hover:not(:disabled) {
  background: var(--cui-primary-soft-hover);
}

/* ---------- outline (outline-primary is the same, kept for old screens) ---------- */

.cbtn-outline,
.cbtn-outline-primary {
  background: var(--cui-bg);
  color: var(--cui-primary);
  border-color: var(--cui-primary-border);
}

.cbtn-outline:hover:not(:disabled),
.cbtn-outline-primary:hover:not(:disabled) {
  background: var(--cui-primary-soft);
  border-color: var(--cui-primary);
}

/* ---------- danger: soft red (remove row, cancel item) ---------- */

.cbtn-danger {
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
  border-color: var(--cui-danger-border);
}

.cbtn-danger:hover:not(:disabled) {
  background: var(--cui-danger-soft-hover);
  border-color: var(--cui-danger);
}

.cbtn-danger:focus-visible,
.cbtn-danger-solid:focus-visible {
  box-shadow: 0 0 0 3px var(--cui-danger-ring);
}

/* ---------- danger-solid: confirm a destructive action ---------- */

.cbtn-danger-solid {
  background: var(--cui-danger);
  color: var(--cui-text-on-primary);
  box-shadow: 0 6px 16px -6px rgba(217, 45, 32, 0.5);
}

.cbtn-danger-solid:hover:not(:disabled) {
  background: var(--cui-danger-hover);
}

/* ---------- ghost: no background until hover ---------- */

.cbtn-ghost {
  background: transparent;
  color: var(--cui-text-muted);
}

.cbtn-ghost:hover:not(:disabled) {
  background: var(--cui-bg-hover);
  color: var(--cui-text);
}

/* ---------- link: looks like a text link ---------- */

.cbtn-link {
  min-height: 0;
  padding-left: 2px;
  padding-right: 2px;
  background: transparent;
  color: var(--cui-primary);
}

.cbtn-link:hover:not(:disabled) {
  text-decoration: underline;
}

/* ---------- icon ---------- */

.cbtn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cbtn-icon svg {
  width: 1em;
  height: 1em;
}

.cbtn-sm .cbtn-icon svg {
  width: 14px;
  height: 14px;
}

.cbtn-lg .cbtn-icon svg {
  width: 18px;
  height: 18px;
}

.cbtn-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- loading spinner ---------- */

.cbtn-spinner {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: cbtn-spin 0.7s linear infinite;
}

.cbtn-secondary .cbtn-spinner,
.cbtn-outline .cbtn-spinner,
.cbtn-outline-primary .cbtn-spinner,
.cbtn-ghost .cbtn-spinner,
.cbtn-link .cbtn-spinner {
  border-color: var(--cui-primary-ring);
  border-top-color: var(--cui-primary);
}

.cbtn-danger .cbtn-spinner {
  border-color: var(--cui-danger-ring);
  border-top-color: var(--cui-danger);
}

/* ---------- icon-only buttons (no visible label) ---------- */

.cbtn-iconOnly {
  gap: 0;
  padding: 0;
  flex-shrink: 0;
}

.cbtn-iconOnly.cbtn-sm {
  width: 32px;
  height: 32px;
}

.cbtn-iconOnly.cbtn-md {
  width: var(--cui-control-height);
  height: var(--cui-control-height);
}

.cbtn-iconOnly.cbtn-lg {
  width: 48px;
  height: 48px;
}

@keyframes cbtn-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomButton/CustomButton.css"],"names":[],"mappings":"AAAA;mCACmC;;AAEnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iDAAiD;EACjD,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB;;iCAE+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,8EAA8E;;AAE9E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sEAAsE;;AAEtE;EACE,iFAAiF;EACjF,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iEAAiE;;AAEjE;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sFAAsF;;AAEtF;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;;EAEE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,qEAAqE;;AAErE;EACE,kCAAkC;EAClC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA,qEAAqE;;AAErE;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2DAA2D;;AAE3D;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;;AAE/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0CAA0C;;AAE1C;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;;;;EAKE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA,+DAA+D;;AAE/D;EACE,MAAM;EACN,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Colours come from CustomTheme/customTheme.css so buttons match\n   every other Custom* component. */\n\n.cbtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: var(--cui-border-width) solid transparent;\n  border-radius: var(--cui-radius);\n  font-family: inherit;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  white-space: nowrap;\n  text-decoration: none;\n  transition: background var(--cui-transition), border-color var(--cui-transition),\n    color var(--cui-transition), box-shadow var(--cui-transition), transform 0.05s ease,\n    opacity var(--cui-transition);\n}\n\n.cbtn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.cbtn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.cbtn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.cbtn-full {\n  width: 100%;\n}\n\n/* ---------- sizes (md matches the input height so rows line up) ---------- */\n\n.cbtn-sm {\n  min-height: 32px;\n  padding: 5px 12px;\n  font-size: 12.5px;\n}\n\n.cbtn-md {\n  min-height: var(--cui-control-height);\n  padding: 8px 16px;\n  font-size: 13.5px;\n}\n\n.cbtn-lg {\n  min-height: 48px;\n  padding: 11px 22px;\n  font-size: 15px;\n}\n\n/* ---------- primary: solid brand colour (submit / save) ---------- */\n\n.cbtn-primary {\n  background: linear-gradient(135deg, var(--cui-primary), var(--cui-primary-light));\n  color: var(--cui-text-on-primary);\n  box-shadow: 0 6px 16px -6px rgba(79, 95, 232, 0.55);\n}\n\n.cbtn-primary:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n\n/* ---------- secondary: soft tint (search / filter) ---------- */\n\n.cbtn-secondary {\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n}\n\n.cbtn-secondary:hover:not(:disabled) {\n  background: var(--cui-primary-soft-hover);\n}\n\n/* ---------- outline (outline-primary is the same, kept for old screens) ---------- */\n\n.cbtn-outline,\n.cbtn-outline-primary {\n  background: var(--cui-bg);\n  color: var(--cui-primary);\n  border-color: var(--cui-primary-border);\n}\n\n.cbtn-outline:hover:not(:disabled),\n.cbtn-outline-primary:hover:not(:disabled) {\n  background: var(--cui-primary-soft);\n  border-color: var(--cui-primary);\n}\n\n/* ---------- danger: soft red (remove row, cancel item) ---------- */\n\n.cbtn-danger {\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n  border-color: var(--cui-danger-border);\n}\n\n.cbtn-danger:hover:not(:disabled) {\n  background: var(--cui-danger-soft-hover);\n  border-color: var(--cui-danger);\n}\n\n.cbtn-danger:focus-visible,\n.cbtn-danger-solid:focus-visible {\n  box-shadow: 0 0 0 3px var(--cui-danger-ring);\n}\n\n/* ---------- danger-solid: confirm a destructive action ---------- */\n\n.cbtn-danger-solid {\n  background: var(--cui-danger);\n  color: var(--cui-text-on-primary);\n  box-shadow: 0 6px 16px -6px rgba(217, 45, 32, 0.5);\n}\n\n.cbtn-danger-solid:hover:not(:disabled) {\n  background: var(--cui-danger-hover);\n}\n\n/* ---------- ghost: no background until hover ---------- */\n\n.cbtn-ghost {\n  background: transparent;\n  color: var(--cui-text-muted);\n}\n\n.cbtn-ghost:hover:not(:disabled) {\n  background: var(--cui-bg-hover);\n  color: var(--cui-text);\n}\n\n/* ---------- link: looks like a text link ---------- */\n\n.cbtn-link {\n  min-height: 0;\n  padding-left: 2px;\n  padding-right: 2px;\n  background: transparent;\n  color: var(--cui-primary);\n}\n\n.cbtn-link:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n/* ---------- icon ---------- */\n\n.cbtn-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cbtn-icon svg {\n  width: 1em;\n  height: 1em;\n}\n\n.cbtn-sm .cbtn-icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.cbtn-lg .cbtn-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.cbtn-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---------- loading spinner ---------- */\n\n.cbtn-spinner {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: cbtn-spin 0.7s linear infinite;\n}\n\n.cbtn-secondary .cbtn-spinner,\n.cbtn-outline .cbtn-spinner,\n.cbtn-outline-primary .cbtn-spinner,\n.cbtn-ghost .cbtn-spinner,\n.cbtn-link .cbtn-spinner {\n  border-color: var(--cui-primary-ring);\n  border-top-color: var(--cui-primary);\n}\n\n.cbtn-danger .cbtn-spinner {\n  border-color: var(--cui-danger-ring);\n  border-top-color: var(--cui-danger);\n}\n\n/* ---------- icon-only buttons (no visible label) ---------- */\n\n.cbtn-iconOnly {\n  gap: 0;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.cbtn-iconOnly.cbtn-sm {\n  width: 32px;\n  height: 32px;\n}\n\n.cbtn-iconOnly.cbtn-md {\n  width: var(--cui-control-height);\n  height: var(--cui-control-height);\n}\n\n.cbtn-iconOnly.cbtn-lg {\n  width: 48px;\n  height: 48px;\n}\n\n@keyframes cbtn-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
